export const dataHooks = {
  liveRegionCount: 'liveRegion-count',
  liveRegionButton: 'liveRegion-button',
};
